import {
  insertClient,
  getAllClients,
  getClientById,
  editClient,
  deleteClient,
  getClients,
  getClientCategoryTree,
  updateClientCategoryMapping,
  getCurrencies,
} from '../../../api/divvy-manageClients';

const manageClients = {
  namespaced: true,
  state: () => ({
    currencies: null,
    clients: [],
    form: {
      reconcile: 1,
      name: '',
      billingcode: '',
      deleted: false,
      clienttheme: '',
      processorders: true,
      currency: 1,
      ratio: null,
      custom: null,
      directory: '',
      mallLogo: false,
      slotmachine: false,
      productsonly: false,
      allowSExcellence: false,
      allowBatchUpload: false,
      allowuseredit: false,
      allowmultiuseredit: false,
      showNewAdmin: false,
      allowPopup: false,
      allowQuiz: false,
      forceEmail: false,
      orderApproval: false,
      showpointranges: false,
      showproductpoints: false,
      showcategories: false,
      newsiteuser: false,
      categories: '1537,1777,1519,1538,1',
      showsearch: false,
      company: '',
      bulletin: 0,
      frontpage: true,
      background: '',
      bgcolor: '',
      txtcolor: 'White',
      program_name: '',
      program_desc: '',
      logo: '',
      copy: '',
      use_password: false,
      username_txt: '',
      password_txt: '',
      image_bottom: '',
      image_left: '',
      image_right: '',
      useCo_Address: false,
      showorder: false,
      showtracking: false,
      showbb: false,
      showchangepassword: false,
      showdescription: false,
      showselectproducts: false,
      showbroadcastemail: false,
      showorderstatus: false,
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      categories_featured: null,
      productindex_page: '',
      registrationallow: false,
      registrationnotification: '',
      registrationwelcome: '',
      side_bgcolor: '',
      side_textcolor: '',
      side_ShowAddPointsLink: false,
      AddPoints_ShowAllButtons: false,
      disclaimer: '',
      capturessnfedid: 0,
      AllowSendPassword: false,
      taico_email: '',
      require_pid_batchtool: false,
      taico_phone: '',
      AmazonTag: '',
      AmazonSubTag: '',
      allowTax: false,
      allowTaxPartial: false,
      taxPercentage: 0,
      maxpointvalue: null,
      minpointvalue: null,
      security: false,
      loginImage: '',
      hpMessage: '',
      directoryDriver: false,
      hpImage: '',
      hpBlogURL: '',
      hpBlog1URL: '',
      hpBlog2URL: '',
      hpBlog3URL: '',
      blogheading: '',
      showwishlist: false,
      headertitle: '',
      headercolor: 'Orange',
      headerfontcolor: 'White',
      buttoncolor: 'Orange',
      buttonfontcolor: 'White',
      Isothercntry: false,
      showace: false,
      showbravo: false,
      showacepoints: false,
      showbravopoints: false,
      aceheadercolor: 'Orange',
      aceheaderfontcolor: 'White',
      acebuttoncolor: 'Orange',
      acebuttonfontcolor: 'White',
      bravoheadercolor: 'Orange',
      bravoheaderfontcolor: 'White',
      bravobuttoncolor: 'Orange',
      bravobuttonfontcolor: 'White',
      quarterlystart: 1,
      showtraining: false,
      customerID: null,
      parentID: null,
      unitTypeID: null,
      showNominations: false,
      showDashboard: false,
      hidePoints: false,
      showclientsecurepassword: false,
      showServicesAwards: false,
      showSocialRecognition: false,
      summaryMessages: false,
      serviceAwardstimePeriod: '',
      maxNumberParticipantsToShow: null,
      allowSharingOrderedItems: false,
      maxNumberNotificationsToShow: null,
      maxNumberContactsToShow: null,
      videoheading: '',
      socialRecognitionFilteredWords: '',
      serviceRewardsRecognitionTeamName: '',
      peerToPeerAwardsTitle: '',
      managerToPeerAwardsTitle: '',
      milestonesAndServiceAnniversariesTitle: '',
      pointsProgramsTitle: '',
      notificationsTitle: '',
      todaysBirthdaysTitle: '',
      todaysServiceAnniversariesTitle: '',
      contactsListTitle: '',
      contactListDisplayed: false,
      serviceawardsingleorder: false,
      clientordermessage: '',
      hprightvideo: '',
      spwhatshottitle: '',
      grossUpTax: false,
    },
    client: {
      id: null,
      reconcile: 1,
      name: '',
      billingcode: '',
      deleted: false,
      clienttheme: '',
      processorders: true,
      currency: 1,
      ratio: 1.2,
      custom: null,
      directory: '',
      mallLogo: false,
      slotmachine: false,
      productsonly: false,
      allowSExcellence: false,
      allowBatchUpload: false,
      allowuseredit: false,
      allowmultiuseredit: false,
      showNewAdmin: false,
      allowPopup: false,
      allowQuiz: false,
      forceEmail: false,
      orderApproval: false,
      showpointranges: false,
      showproductpoints: false,
      showcategories: false,
      newsiteuser: false,
      categories: '1537,1777,1519,1538,1',
      showsearch: false,
      company: '',
      bulletin: 0,
      frontpage: false,
      background: '',
      bgcolor: '',
      txtcolor: 'White',
      program_name: '',
      program_desc: '',
      logo: '',
      copy: '',
      use_password: false,
      username_txt: '',
      password_txt: '',
      image_bottom: '',
      image_left: '',
      image_right: '',
      useCo_Address: false,
      showorder: false,
      showtracking: false,
      showbb: false,
      showchangepassword: false,
      showdescription: false,
      showselectproducts: false,
      showbroadcastemail: false,
      showorderstatus: false,
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      categories_featured: null,
      productindex_page: '',
      registrationallow: false,
      registrationnotification: '',
      registrationwelcome: '',
      side_bgcolor: '',
      side_textcolor: '',
      side_ShowAddPointsLink: false,
      AddPoints_ShowAllButtons: false,
      disclaimer: '',
      capturessnfedid: 0,
      AllowSendPassword: false,
      taico_email: '',
      require_pid_batchtool: false,
      taico_phone: '',
      AmazonTag: '',
      AmazonSubTag: '',
      allowTax: false,
      allowTaxPartial: false,
      taxPercentage: 0,
      maxpointvalue: null,
      minpointvalue: null,
      security: false,
      loginImage: '',
      hpMessage: '',
      directoryDriver: false,
      hpImage: '',
      hpBlogURL: '',
      hpBlog1URL: '',
      hpBlog2URL: '',
      hpBlog3URL: '',
      blogheading: '',
      showwishlist: false,
      headertitle: '',
      headercolor: 'Orange',
      headerfontcolor: 'White',
      buttoncolor: 'Orange',
      buttonfontcolor: 'White',
      Isothercntry: false,
      showace: false,
      showbravo: false,
      showacepoints: false,
      showbravopoints: false,
      aceheadercolor: 'Orange',
      aceheaderfontcolor: 'White',
      acebuttoncolor: 'Orange',
      acebuttonfontcolor: 'White',
      bravoheadercolor: 'Orange',
      bravoheaderfontcolor: 'White',
      bravobuttoncolor: 'Orange',
      bravobuttonfontcolor: 'White',
      quarterlystart: 1,
      showtraining: false,
      customerID: null,
      parentID: null,
      unitTypeID: null,
      showNominations: false,
      showDashboard: false,
      hidePoints: false,
      showclientsecurepassword: false,
      showServicesAwards: false,
      showSocialRecognition: false,
      summaryMessages: false,
      serviceAwardstimePeriod: '',
      maxNumberParticipantsToShow: null,
      allowSharingOrderedItems: false,
      maxNumberNotificationsToShow: null,
      maxNumberContactsToShow: null,
      videoheading: '',
      socialRecognitionFilteredWords: '',
      serviceRewardsRecognitionTeamName: '',
      peerToPeerAwardsTitle: '',
      managerToPeerAwardsTitle: '',
      milestonesAndServiceAnniversariesTitle: '',
      pointsProgramsTitle: '',
      notificationsTitle: '',
      todaysBirthdaysTitle: '',
      todaysServiceAnniversariesTitle: '',
      contactsListTitle: '',
      contactListDisplayed: false,
      serviceawardsingleorder: false,
      clientordermessage: '',
      hprightvideo: '',
      spwhatshottitle: '',
      grossUpTax: false,
    },
  }),

  getters: {
    allClients: (state) => state.clients,
    clientById: (state) => state.client,
  },

  actions: {
    fetchAllClients({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAllClients(data)
          .then((resp) => {
            console.log(resp, 'from getAllClients');
            commit('SET_CLIENTS', resp);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err, 'from getAllSuppliers');
          });
      });
    },

    fetchClientById({ commit }, params) {
      return new Promise((resolve, reject) => {
        getClientById(params)
          .then((resp) => {
            console.log(resp, 'from getClientbyId action');
            commit('SET_CLIENT_BY_ID', resp);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err, 'from getClientbyId action');
          });
      });
    },

    addClient({ commit }, form) {
      return new Promise((resolve, reject) => {
        insertClient(form)
          .then((resp) => {
            resolve(resp);
          })
          .catch(() => {
            console.log('error from add supplier action');
          });
      });
    },

    updateClient({ commit }, client) {
      return new Promise((resolve, reject) => {
        editClient(client)
          .then((resp) => {
            console.log(resp, 'from update client action');
            resolve(resp);
          })
          .catch(() => {
            console.log('error from update client action');
          });
      });
    },
    removeClient({ commit }, id) {
      return new Promise((resolve, reject) => {
        deleteClient(id)
          .then((resp) => {
            console.log(resp, 'from delete client action');
            resolve(resp);
          })
          .catch(() => {
            console.log('error from delete client action');
          });
      });
    },

    getClientCategoryTree({ commit }, payload) {
      return new Promise((resolve, reject) => {
        addProductImage(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err, 'error from getClientCategoryTree action');
          });
      });
    },

    getClients() {
      return new Promise((resolve, reject) => {
        getClients()
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err, 'error from getClients action');
          });
      });
    },

    getClientCategoryTree({}, payload) {
      return new Promise((resolve, reject) => {
        getClientCategoryTree(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err, 'error from getClientCategoryTree action');
          });
      });
    },

    updateClientCategoryMapping({}, payload) {
      return new Promise((resolve, reject) => {
        updateClientCategoryMapping(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err, 'error from updateClientCategoryMapping action');
          });
      });
    },

    getCurrencies({ commit }) {
      return new Promise((resolve, reject) => {
        getCurrencies()
          .then((data) => {
            commit('SET_CURRENCIES', data);
            resolve(data);
          })
          .catch((err) => {
            console.log(err, 'error from getCurrencies action');
          });
      });
    },
  },

  mutations: {
    SET_CLIENTS: (state, clients) => {
      clients.Result = clients.Result ?? [];
      state.clients = clients;
    },
    SET_CLIENT_BY_ID: (state, client) => {
      state.client = client;
    },
    SET_CURRENCIES: (state, data) => {
      state.currencies = data;
    },
  },
};

export default manageClients;
